import { render, staticRenderFns } from "./dongligl.vue?vue&type=template&id=4934d6a6&scoped=true&"
import script from "./dongligl.vue?vue&type=script&lang=js&"
export * from "./dongligl.vue?vue&type=script&lang=js&"
import style0 from "./dongligl.vue?vue&type=style&index=0&id=4934d6a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4934d6a6",
  null
  
)

export default component.exports